module.exports = __webpack_public_path__ + "static/ag-grid-inverted-8f9cba97e2b1424bb991f901496d4ba0.svg";